import React, { useEffect, useState } from 'react';
import { FaCircleNotch, FaHourglassHalf, FaRobot } from 'react-icons/fa';
import { motion } from 'framer-motion';

const containerStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '40px',
  // backgroundColor: '#f8f9fa', // light gray Bootstrap bg
  // borderRadius: '10px',
  // border: '1px solid #dee2e6',
  marginTop: '40px',
  minHeight: '200px'
};

const messageStyle: React.CSSProperties = {
  fontSize: '1.2rem',
  color: '#212529',
  textAlign: 'center'
};

const iconWrapperStyle: React.CSSProperties = {
  display: 'inline-block',
  width: '40px',
  height: '40px',
  marginBottom: '10px'
};

const iconStyle: React.CSSProperties = {
  fontSize: '2.5rem',
  color: '#198754',
  width: '100%',
  height: '100%',
};

const iconStyle2: React.CSSProperties = {
  fontSize: '2.5rem',
  color: '#198754', // Bootstrap green
  marginBottom: '10px'
};

interface request {
  msg: string
}

const LoadingRequest: React.FC<request> = ({ msg }) => {
  const [stage, setStage] = useState(0);

  useEffect(() => {
    const timers = [
      setTimeout(() => setStage(1), 2000), // after 2s
      setTimeout(() => setStage(2), 5000), // after 5s
    ];
    return () => timers.forEach(clearTimeout);
  }, []);

  const stages = [
    {
      icon: (
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 1, ease: 'linear' }}
          style={{ ...iconWrapperStyle }}
        >
          <FaCircleNotch style={iconStyle} />
        </motion.div>
      ),
      text: msg
    },
    {
      icon: <FaHourglassHalf style={iconStyle2} />,
      text: 'Still working on it...'
    },
    {
      icon: <FaRobot style={iconStyle2} />,
      text: 'This one’s taking longer than usual. Assembling data with magic... 🤖'
    }
  ];

  return (
    <motion.div
      style={containerStyle}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      {stages[stage].icon}
      <div style={messageStyle}>{stages[stage].text}</div>
    </motion.div>
  );
};

export default LoadingRequest;
